import { faEye, faPlug } from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { SidebarContentAdmin } from "./SidebarContentSettings";

export const UserSettingsMenu = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <SidebarContentAdmin
      title="User Settings"
      settings={[
        {
          name: "Connections",
          link: { to: "/u/settings" as const },
          icon: faPlug,
          onClick: () => scrollToSection("connections"),
        },
        {
          name: "Overlays",
          link: { to: "/u/settings" as const },
          icon: faEye,
          systemRole: "super",
          onClick: () => scrollToSection("overlays"),
        },
      ]}
    />
  );
};
